<template>
    <div class="all-workouts">

        <WorkoutFilter v-if="filtersOpen"></WorkoutFilter>

        <div class="module module--space-default">
            <template v-if="allWorkouts !== false">
                <div class="all-workouts__top">
                    <div class="container container--nooverflow all-workouts__top__container">
                        <h1 class="all-workouts__title">
                            {{mainTitle}}
                            <span class="up-text text text--large">{{filteredWorkouts.length}}</span>
                        </h1>
                        <div class="all-workouts__sort">
                            <div class="all-workouts__sort__title h6"><translate>sort_by</translate>:</div>
                            <v-select 
                                class="all-workouts__sort__input" 
                                v-model="sortby" 
                                :options="sortingOptions" 
                                :clearable="false"
                            ></v-select>
                        </div>
                    </div>
                </div>
                <div class="all-workouts__filter-list" v-if="filterList.length">
                    <div class="container">
                        <div class="all-workouts__filter-list__inner">
                            <div class="all-workouts__filter-list__item all-workouts__filter-list__item--button" @click="clearFilters" v-translate>clear_all</div>
                            <div class="all-workouts__filter-list__item" v-for="currentFilter in filterList" :key="currentFilter.id" @click="removeFilter(currentFilter.type, currentFilter.id)">
                                <span>{{ currentFilter.name }}</span>
                                <icon class="all-workouts__filter-list__item__icon" name="close"></icon>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="all-workouts__list">
                    <WorkoutList :workouts="filteredWorkouts" :sorting="sortby.value"></WorkoutList>
                </div>
            </template>
            <div class="all-workouts__loader" v-else>
                <Loader></Loader>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from '../api'
import { mapGetters } from "vuex"

import WorkoutList from "@/components/WorkoutList.vue";
import WorkoutFilter from "@/components/WorkoutFilter.vue";

import {addTrackingObject} from "@/utils/tracking"


export default {
    components: {
        WorkoutList,
        WorkoutFilter,
    },
    data () {
        return {
            filter: this.$route.params.filter,
            filtersOpen: this.$route.query.mode === 'filters',
            title: this.$gettext('workouts'),
            allWorkouts: false,
            sortingOptions: [
                {label: this.$gettext('most_relevant'), value: 'relevant'},
                {label: this.$gettext('duration_ascending'), value: 'duration-asc'},
                {label: this.$gettext('duration_descending'), value: 'duration-desc'},
            ],
            sortby: {label: this.$gettext('most_relevant'), value: 'relevant'},
        }
    },
    watch: {
        $route(to, from) {
            this.filtersOpen = this.$route.query.mode !== undefined && this.$route.query.mode === 'filters';
        }
    },
    mounted () {
        this.fetchData();

        if(this.filtersOpen) {
            addTrackingObject({subSection: "home", screenName: "searchWorkoutsResults"});
        } else {
            addTrackingObject({subSection: "home", screenName: "filterWorkouts"});
        }
    },
    destroyed() {
        this.clearFilters();
    },
    computed: {
        ...mapGetters(['trainers', 'searchTerm', 'filters']),
        filteredWorkouts() {
            let workouts = false
            if(this.filter !== '' && this.filter !== undefined) {
                workouts = this.allWorkouts.filter(workout => {
                    return workout.kind === this.$gettext('workout')
                })
            } else {
                workouts = this.allWorkouts
            }
            
            workouts = this.checkForFilters(workouts)
            workouts = this.checkForSearchTerm(workouts)

            return workouts
        },
        mainTitle() {
            if(this.filter) {
                return this.title
            } else if(this.searchTerm  && this.searchTerm !== '') {
                return this.searchTerm   
            } else {
                return this.$gettext('workouts')
            }
        },
        filterList() {
            let response = [];
            for (var type of Object.keys(this.filters)) {
                if(Array.isArray(this.filters[type])) {
                    response = [...response, ...this.filters[type]];
                } else if (this.filters[type].id !== undefined) {
                    response.push(this.filters[type]);
                }
            }
            return response;
        }
    },
    methods: {
        checkForSearchTerm(workouts) {
            let searchedWorkouts = workouts
            if(this.searchTerm && this.searchTerm !== '') {
                searchedWorkouts = workouts.filter(workout => {
                    const lowerCaseSearchTerm = this.searchTerm.toLowerCase().trim()
                    const title = workout.title.toLowerCase()
                    const subtitle = workout.subtitle.toLowerCase()
                    const trainer = workout.trainer.name.toLowerCase()
                    const difficulty = workout.difficulty.toLowerCase()
                    return title.includes(lowerCaseSearchTerm) || subtitle.includes(lowerCaseSearchTerm) || trainer.includes(lowerCaseSearchTerm) || difficulty.includes(lowerCaseSearchTerm)
                })
            }

            return searchedWorkouts
        },
        async fetchData() {
            try {
                let listResponse = false
                let workoutResponse = false
                if(this.filter !== '' && this.filter !== undefined) {
                    listResponse = await api.opportunities.lists()
                    workoutResponse = await api.opportunities.lists({sectionType : this.filter})
                    if(listResponse) {
                        const matchingSectionItem = listResponse.data.data.sections.find(section => {
                            return section.id === this.filter
                        })
                        if(matchingSectionItem) {
                            this.title = matchingSectionItem.title
                        }
                    }
                    this.allWorkouts = workoutResponse.data.data
                } else {
                    let params = {}
                    workoutResponse = await api.workout.all({params: params})
                    this.allWorkouts = workoutResponse.data.data
                }
                
            } catch (error) {
                console.error(error);
            }
        },
        checkForFilters(workouts) {
            let filteredWorkouts = workouts.filter(this.filterWorkouts);
            return filteredWorkouts;
        },
        filterWorkouts(workout){
         
            // levels
            if(this.filters.levels.length && workout.difficulty !== undefined) {
                let levelsMatch = this.filters.levels.filter(level => level.id === workout.difficulty).length;
                if(!levelsMatch) return false;
            }
        
            // goals
            if(this.filters.goals.length && workout.goal !== undefined) {
                let goalsMatch = this.filters.goals.filter(goal => goal.id === workout.goal.id).length;
                if(!goalsMatch) return false;
            }
        
            // interests
            if(this.filters.interests.length && workout.interests !== undefined) {
                let interestsMatch = this.filters.interests.filter((interest) => 
                    {
                        return workout.interests.filter(workoutInterest => workoutInterest.id === interest.id).length
                    }
                ).length
                if(!interestsMatch) return false;
            }
              
            // trainers
            if(this.filters.trainers.length && workout.trainer !== undefined) {
                let trainersMatch = this.filters.trainers.filter(trainer => trainer.id === workout.trainer.id).length;
                if(!trainersMatch) return false;
            }
              
            // duration
            if(this.filters.duration.from !== undefined && workout.duration !== undefined) {
                const minDuration = this.filters.duration.from
                const maxDuration = this.filters.duration.to >= 60 * 60 ? 60 * 60 * 3 : this.filters.duration.to
                let durationMatches = minDuration <= workout.duration && maxDuration >= workout.duration;
                if(!durationMatches) return false;
            }

            return true;
        },
        removeFilter(type, id) {
            this.$store.commit('removeFilterOfType', {type, id});
        },
        clearFilters(){
            this.$store.commit('removeAllFilters');
        }
    },
}

</script>

<style scoped lang="scss">
.all-workouts {
    $block: &;

    &__top {
        padding: 0 0 20px;
        margin: -20px 0 40px;
        border-bottom: 1px solid rgba(black, 0.1);

        &__container {
            display: flex;
            align-items: center;
            justify-content: space-between;

            @include mq($until: tablet) {
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
            }
        }
    }

    &__loader {
        display: flex;
        justify-content: center;
    }
    
    &__sort {
        display: flex;
        align-items: center;

        @include mq($until: tablet) {
            margin-top: 20px;
            width: 100%;
        }

        &__title {
            margin-right: 20px;
            text-transform: uppercase;
        }

        &__input {
            min-width: 220px;
        }
    }

    &__filter-list {
        margin-top: -15px;
        margin-bottom: 20px;
        &__inner {
            display: flex;
            flex-wrap: wrap;
        }
        &__item {
            transition: 0.15s;
            padding: 0.3em 1em;
            border-radius: 30px;
            font-size: $puma-size-font-sm;
            margin-right: 0.5em;
            margin-bottom: 0.5em;
            cursor: pointer;
            user-select: none;
            background-color: $puma-color-black;
            color: $puma-color-white;
            display: flex;
            align-items: center;
            &--button {
                background-color: transparent;
                border: 1px solid $puma-color-neutral-20;
                color: $puma-color-black;
                &:hover {
                    background-color: $puma-color-black;
                    color: $puma-color-white;
                    border-color: transparent;
                }
            }
            &__icon {
                width: 1.25em;
                height: 1.25em;
                margin-left: 0.5em;
                @include mq($until: tablet) {

                }
            }
        }
    }
}
</style>